import axios from "axios";

import {
	FrontendEndpointsTypes,
	TXRequestConfig,
} from "@server/interfaces/frontend-api";

/** a 401 from these means bad credentials, not a lost session */
const LOGIN_PATHS = ["/vendor/login", "/vendor/login-with-token"];

export class APIService {
	// logURL= "/services/"
	baseURL = "/api";

	/** invokes the handler when the server rejects our session, so the app can log out */
	public onUnauthorized(handler: () => void) {
		axios.interceptors.response.use(undefined, (error) => {
			const url = error?.config?.url ?? "";
			const isLoginRequest = LOGIN_PATHS.some(
				(path) => url === `${this.baseURL}${path}`
			);

			if (error?.response?.status === 401 && !isLoginRequest) {
				handler();
			}

			return Promise.reject(error);
		});
	}

	public get<T>(url: string, config?: TXRequestConfig) {
		// TODO - set headers as needed

		return axios.get<T>(url, config);
	}

	public post<T>(url: string, data: T, config?: TXRequestConfig) {
		// TODO - set headers as needed

		return axios.post(url, data, config);
	}

	public put<T>(url: string, data: T, config?: TXRequestConfig) {
		// TODO - set headers as needed

		return axios.put(url, data, config);
	}

	public async api<
		PATH extends keyof FrontendEndpointsTypes,
		PARAMS extends Parameters<FrontendEndpointsTypes[PATH]>[0],
		RESPONSE extends Awaited<ReturnType<FrontendEndpointsTypes[PATH]>>
	>(path: PATH, params?: PARAMS) {
		const url = `${this.baseURL}${path}`;
		axios.defaults.withCredentials = true;

		const response = await axios.post<RESPONSE>(url, params, {
			responseType: "json",
			// withCredentials: true,
		});

		return response;
	}
}
